
import * as defaultImport from "@splunk/visualization-encoding/utils/findClosestMatchFromDefaultList";
export * from "@splunk/visualization-encoding/utils/findClosestMatchFromDefaultList";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
